import React, { Component } from 'react';
import Select from 'react-select';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';

class Competitor extends Component {

    render = () => {
        const { otherCompetitor, showOtherField, selectedCompetitor, percentageValue, 
            handleAddClick, handleCompetitorChange, handleChange, isDisabled, competitors } = this.props;
        
        return (
            <React.Fragment>

                <Grid item xs={12} sm={showOtherField ? 3 : 6}>
                    <Select
                        className="basic-single"
                        classNamePrefix="select"
                        value={selectedCompetitor}
                        isDisabled={isDisabled}
                        onChange={handleCompetitorChange}
                        isSearchable={true}
                        id="competitors"
                        name="competitors"
                        options={competitors.filter(competitor => competitor.Status === "Active")}
                    />
                </Grid>
                {showOtherField && (
                    <Grid item xs={12} sm={4}>
                        <TextField
                            variant="standard"
                            required
                            id="otherCompetitor"
                            name="otherCompetitor"
                            value={otherCompetitor}
                            onChange={handleChange('otherCompetitor')}
                            label="company name"
                        />
                    </Grid>
                )}
                <Grid item xs={5} sm={showOtherField ? 3 : 4}>
                    <TextField
                        variant="standard"
                        required
                        id="percentage"
                        name="percentage"
                        value={percentageValue}
                        onChange={handleChange('percentage')}
                        label="% of business"
                    />
                </Grid>
                <Grid item xs={1} sm={2} sx={{ display: 'flex', alignItems: 'center' }}>
                    <Fab
                        size="small"
                        color="primary"
                        aria-label="Add"
                        onClick={handleAddClick}
                        disabled={
                            percentageValue === '' || percentageValue < 0 ||
                            !selectedCompetitor || selectedCompetitor.value === '' ||
                            (selectedCompetitor.value === 'Other' && otherCompetitor === '')
                        }
                    >
                        <AddIcon />
                    </Fab>
                </Grid>
            </React.Fragment>
        );
    };

}


export default Competitor;
